/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_Buying_GroupsInputs */

const en_nav_buying_groups = /** @type {(inputs: Nav_Buying_GroupsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Buying groups`)
};

/**
* | output |
* | --- |
* | "Buying groups" |
*
* @param {Nav_Buying_GroupsInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const nav_buying_groups = /** @type {((inputs?: Nav_Buying_GroupsInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_Buying_GroupsInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_nav_buying_groups(inputs)
});